<template>
<!-- 教师端微信小程序配置业务域名需要的校验文件 -->
  <div class="">7c41a3c6b5a69444e27db81aa6884c47</div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>